import { render, staticRenderFns } from "./PromoCodes.vue?vue&type=template&id=797f9be8&scoped=true&"
import script from "./PromoCodes.vue?vue&type=script&lang=ts&"
export * from "./PromoCodes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797f9be8",
  null
  
)

export default component.exports